import { FaFutbol, FaArrowRight, FaUserPlus } from "react-icons/fa";
import "../../Components/Layout/football-details.css";
import "./login.css";
import {
  Button,
  FormControl,
  FormLabel,
  Input,
  Stack,
  useToast,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  useDisclosure,
  Checkbox,
} from "@chakra-ui/react";
import { useLoginScreen } from "./userLoginScreen";
import { newPlayer } from "../../Services/home";
import { useEffect, useState } from "react";

export const LoginScreen: React.FC = () => {
  const toast = useToast();
  const { isOpen, onOpen, onClose } = useDisclosure();

  type BeforeInstallPromptEvent = Event & {
    prompt: () => void;
    userChoice: Promise<{ outcome: "accepted" | "dismissed" }>;
  };

  const [rememberMe, setRememberMe] = useState(false);
  const [storedLogin, setStoredLogin] = useState({
    cellPhone: "",
    password: "",
  });

  const [deferredPrompt, setDeferredPrompt] =
    useState<BeforeInstallPromptEvent | null>(null);
  const [isVisible, setIsVisible] = useState(false);

  const {
    playerName,
    cellPhone,
    password,
    playerLogin,
    playerPassword,
    handleCellPhoneChange,
    handlePasswordChange,
    goToHome,
    handlePlayerName,
    handlePlayerLogin,
    handlePlayerPassword,
    setCellPhone,
    setPassword,
  } = useLoginScreen();

  const handleLogin = () => {
    if (cellPhone && password) {
      if (rememberMe) {
        localStorage.setItem(
          "loginData",
          JSON.stringify({ cellPhone, password })
        );
      } else {
        localStorage.removeItem("loginData");
      }
      goToHome();
    } else {
      toast({
        title: "Erro",
        description: "Por favor, preencha todos os campos.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const handleNewUser = async () => {
    if (playerPassword && playerLogin && playerName) {
      await newPlayer(playerLogin, playerPassword, playerName);
      onClose();
      toast({
        title: "Success",
        description: `Olá ${playerName}`,
        status: "success",
        duration: 6000,
        isClosable: true,
      });
    } else {
      toast({
        title: "Erro",
        description: "Por favor, preencha todos os campos.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  useEffect(() => {
    const handleBeforeInstallPrompt = (e: any) => {
      e.preventDefault();
      setDeferredPrompt(e as BeforeInstallPromptEvent);
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);

    return () =>
      window.removeEventListener(
        "beforeinstallprompt",
        handleBeforeInstallPrompt
      );
  }, []);

  const handleInstallClick = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      const choiceResult = await deferredPrompt.userChoice;
      if (choiceResult.outcome === "accepted") {
        console.log("Usuário aceitou instalar o PWA");
      } else {
        console.log("Usuário recusou instalar o PWA");
      }
      setDeferredPrompt(null);
      setIsVisible(false);
    }
  };

  useEffect(() => {
    if (storedLogin.cellPhone && storedLogin.password) {
      setCellPhone(storedLogin.cellPhone);
      setPassword(storedLogin.password);
      setRememberMe(true);
    }
  }, [setCellPhone, setPassword, storedLogin]);

  useEffect(() => {
    const storedData = localStorage.getItem("loginData");
    if (storedData) {
      const parsedData = JSON.parse(storedData);
      setStoredLogin(parsedData);
    }
  }, []);

  return (
    <main className="football-auth">
      <div className="football-auth__pitch" aria-hidden="true"><span /></div>
      <div className="football-auth__shell">
        <header className="football-auth__brand">
          <span className="football-auth__crest" aria-hidden="true"><FaFutbol /></span>
          <div><strong>Lorota Futebol</strong><span>A resenha vira placar.</span></div>
        </header>

        <section className="football-auth__card" aria-labelledby="login-title">
          <div className="football-auth__intro">
            <span className="football-eyebrow">SEU TIME. SEUS NÚMEROS.</span>
            <h1 id="login-title">Entre em campo.</h1>
            <p>Acompanhe os gols, as partidas e a disputa pela artilharia.</p>
          </div>
          <form onSubmit={(event) => { event.preventDefault(); handleLogin(); }}>
            <Stack spacing={4}>
              <FormControl id="login-username" isRequired>
                <FormLabel>Login</FormLabel>
                <Input value={cellPhone} type="text" name="username" autoComplete="username" autoCapitalize="none" spellCheck={false} placeholder="Seu login" onChange={handleCellPhoneChange} />
              </FormControl>
              <FormControl id="login-password" isRequired>
                <FormLabel>Senha</FormLabel>
                <Input value={password} type="password" name="password" autoComplete="current-password" placeholder="Sua senha" onChange={handlePasswordChange} />
              </FormControl>
              <Checkbox className="football-auth__remember" colorScheme="green" isChecked={rememberMe} onChange={(event) => setRememberMe(event.target.checked)}>
                Lembrar a senha
              </Checkbox>
              <Button type="submit" variant="unstyled" className="football-auth__primary" rightIcon={<FaArrowRight />} isFullWidth>Entrar</Button>
            </Stack>
          </form>
          <div className="football-auth__divider"><span>Ainda não faz parte do time?</span></div>
          <Button variant="unstyled" className="football-auth__secondary" leftIcon={<FaUserPlus />} onClick={onOpen} isFullWidth>Criar minha conta</Button>
          {isVisible && <Button variant="unstyled" className="football-auth__install" onClick={handleInstallClick} isFullWidth>Instalar o app</Button>}
        </section>
        <footer className="football-auth__footer"><FaFutbol aria-hidden="true" /> Futebol entre amigos. Números para a história.</footer>
      </div>

      <Modal isOpen={isOpen} onClose={onClose} isCentered scrollBehavior="inside">
        <ModalOverlay bg="blackAlpha.800" />
        <ModalContent className="football-modal" mx={4} maxW="420px">
          <ModalHeader className="football-modal__header">
            <span className="football-eyebrow"><FaFutbol aria-hidden="true" /> NOVO JOGADOR</span>
            <span className="football-modal__name">Entre para o time.</span>
          </ModalHeader>
          <ModalCloseButton className="football-modal__close" aria-label="Fechar cadastro" />
          <ModalBody className="football-modal__body">
            <p className="football-auth__signup-intro">Crie sua conta para acompanhar seu futebol.</p>
            <form id="signup-form" onSubmit={(event) => { event.preventDefault(); handleNewUser(); }}>
              <Stack spacing={4}>
                <FormControl id="signup-name" isRequired>
                  <FormLabel>Nome</FormLabel>
                  <Input value={playerName} placeholder="Como o time chama você?" type="text" name="name" autoComplete="name" onChange={handlePlayerName} />
                </FormControl>
                <FormControl id="signup-login" isRequired>
                  <FormLabel>Login</FormLabel>
                  <Input value={playerLogin} placeholder="Escolha seu login" type="text" name="username" autoComplete="username" autoCapitalize="none" spellCheck={false} onChange={handlePlayerLogin} />
                </FormControl>
                <FormControl id="signup-password" isRequired>
                  <FormLabel>Senha</FormLabel>
                  <Input value={playerPassword} placeholder="Crie sua senha" type="password" name="password" autoComplete="new-password" onChange={handlePlayerPassword} />
                </FormControl>
              </Stack>
            </form>
          </ModalBody>
          <ModalFooter className="football-modal__footer" flexDirection="column" gap={2}>
            <Button type="submit" form="signup-form" variant="unstyled" className="football-save" w="full">Criar conta</Button>
            <Button variant="unstyled" className="football-auth__back" onClick={onClose}>Já tenho conta. Entrar</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </main>
  );
};
